/** @jsxImportSource ../../i18n */
import React from 'react';
import { cx } from '../../theme/cx';

// SIM in electric blue, real money in red with a pulsing dot: the two must
// never be mistaken for one another.
export const EnvBadge = ({ env, className }) => {
  const live = env === 'live';
  return (
    <span
      data-testid="env-badge"
      data-env={env}
      className={cx(
        'inline-flex h-7 items-center gap-2 rounded-full border px-3 text-xs font-bold uppercase tracking-[0.14em]',
        live ? 'border-loss-500/50 bg-loss-900/80 text-loss-200' : 'border-trade-500/40 bg-trade-900/70 text-trade-200',
        className,
      )}
    >
      <span aria-hidden="true" className={cx('h-2 w-2 rounded-full', live ? 'animate-pulse-soft bg-loss-400' : 'bg-trade-400')} />
      {live ? 'Réel' : 'SIM'}
      <span className="sr-only">{live ? ' : ordres en argent réel' : ' : compte de simulation'}</span>
    </span>
  );
};

export default EnvBadge;
